import { useEffect } from 'react';
import { useAccessibilityStore } from '../stores/accessibilityStore';

/**
 * Reflects global accessibility toggles onto the document root as CSS classes so
 * plain CSS (in styles/index.css) can apply them app-wide:
 *   - `a11y-high-contrast`  → stronger borders/text contrast
 *   - `a11y-reduced-motion` → kills transitions/animations
 *
 * Call this ONCE near the app root.
 */
export function useAccessibilityRootClass() {
  const highContrast = useAccessibilityStore((s) => s.highContrast);
  const reducedMotion = useAccessibilityStore((s) => s.reducedMotion);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('a11y-high-contrast', highContrast);
    root.classList.toggle('a11y-reduced-motion', reducedMotion);
  }, [highContrast, reducedMotion]);
}
